import React, { Component } from 'react';

import PaginationComponent from './PaginationComponent';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { getSearchEmptyMessage } from '../utils/tableState';
import { navigateTo } from '../utils/navigation';
import { badgeEstado, textoEstado, nombreTipo, textoReferencia } from '../utils/emailLog';

var config = process.env;

class TableEmailLogComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'created_at',
            sortDir: 'desc',
            status: '',
            templateKey: '',
            from: '',
            to: '',
            data: [],
            summary: null,
            templateKeys: [],
            loaded: false,
        };
    }

    componentDidMount() {
        this.fetchFilters();
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    headers = () => ({
        method: 'GET',
        headers: {
            'access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        },
    })

    // Los combos se pueblan con los valores que REALMENTE hay en la tabla. Hardcodear la lista
    // la deja desactualizada el día que alguien agrega un emisor nuevo (pasó: `envio_gratis_regalado`
    // no está en ninguna lista del código).
    fetchFilters = () => {
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}emailLog/filters`, this.headers())
            .then((r) => r.json())
            .then((data) => {
                if (data.error === 0 && data.data) {
                    this.setState({ templateKeys: data.data.templateKeys || [] });
                }
            })
            .catch(() => { /* los combos son una ayuda: si fallan, los filtros de texto siguen */ });
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        status = this.state.status,
        templateKey = this.state.templateKey,
        from = this.state.from,
        to = this.state.to,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }

        const query = buildPaginationQuery({
            page, limit, search, sortBy, sortDir,
            extraParams: { status, templateKey, from, to },
        });

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}emailLog?${query}`, this.headers())
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    return;
                }
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    summary: (data.data && data.data.summary) || null,
                    search, sortBy, sortDir, status, templateKey, from, to,
                    loaded: true,
                });
            });
    }

    renderLoader = () => (
        <div style={{ background: '#ffffff', borderRadius: '0.625rem', boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)', border: '1px solid #e1e5eb', minHeight: '320px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
            <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                <div className="loader"></div>
            </div>
        </div>
    )

    // Contadores del MISMO filtro que la tabla, más "hace cuánto salió el último mail" — que es
    // la señal más barata de que el sistema dejó de mandar y no existe en ninguna otra pantalla.
    renderResumen = () => {
        const s = this.state.summary;
        if (!s) return null;
        const tile = (titulo, valor, color) => (
            <div className="col-6 col-md-3 mb-2" key={titulo}>
                <div className="card card-small h-100">
                    <div className="card-body p-3">
                        <div className="text-muted" style={{ fontSize: 12 }}>{titulo}</div>
                        <div style={{ fontSize: 20, fontWeight: 600, color }}>{valor}</div>
                    </div>
                </div>
            </div>
        );
        return (
            <div className="row mb-2">
                {tile('Enviados', s.sent, '#17c671')}
                {tile('Fallados', s.failed, s.failed > 0 ? '#c4183c' : undefined)}
                {tile('No enviados', s.skipped, undefined)}
                {/* Este NO respeta el filtro y es a propósito: la pregunta que contesta es "¿el
                    sistema sigue mandando?", y filtrado por un rango viejo diría que sí cuando
                    hace días que no sale nada. El título dice "del sistema" para que no se lea
                    como un dato del filtro, que es lo que son los otros tres. */}
                {tile('Último envío del sistema', s.lastSentAt ? String(s.lastSentAt).slice(0, 16).replace('T', ' ') : '—', undefined)}
            </div>
        );
    }

    renderFiltros = () => (
        <div className="row mb-3">
            <div className="col-md-2 mb-2">
                <label style={{ fontSize: 12 }} htmlFor="filtro_desde">Desde</label>
                <input id="filtro_desde" type="date" className="form-control form-control-sm"
                    value={this.state.from} onChange={(e) => this.fetchData({ page: 1, from: e.target.value })} />
            </div>
            <div className="col-md-2 mb-2">
                <label style={{ fontSize: 12 }} htmlFor="filtro_hasta">Hasta</label>
                <input id="filtro_hasta" type="date" className="form-control form-control-sm"
                    value={this.state.to} onChange={(e) => this.fetchData({ page: 1, to: e.target.value })} />
            </div>
            <div className="col-md-3 mb-2">
                <label style={{ fontSize: 12 }} htmlFor="filtro_estado">Estado</label>
                <select id="filtro_estado" className="form-control form-control-sm"
                    value={this.state.status} onChange={(e) => this.fetchData({ page: 1, status: e.target.value })}>
                    <option value="">Todos</option>
                    <option value="SENT">Enviados</option>
                    <option value="FAILED">Fallados</option>
                    <option value="SKIPPED">No enviados</option>
                </select>
            </div>
            <div className="col-md-3 mb-2">
                <label style={{ fontSize: 12 }} htmlFor="filtro_tipo">Tipo</label>
                <select id="filtro_tipo" className="form-control form-control-sm"
                    value={this.state.templateKey} onChange={(e) => this.fetchData({ page: 1, templateKey: e.target.value })}>
                    <option value="">Todos</option>
                    {this.state.templateKeys.map((k) => (<option key={k} value={k}>{nombreTipo(k)}</option>))}
                </select>
            </div>
            <div className="col-md-2 mb-2 d-flex align-items-end">
                <button type="button" className="btn btn-sm btn-outline-secondary w-100" onClick={this.limpiarFiltros}>
                    Limpiar
                </button>
            </div>
        </div>
    )

    limpiarFiltros = () => {
        // `searchInput` es state local del input (va con debounce) y `search` es el que viajó al
        // backend: limpiar uno solo deja el cuadro de texto escrito y la tabla sin filtrar.
        this.setState({ searchInput: '' });
        this.fetchData({ page: 1, status: '', templateKey: '', from: '', to: '', search: '' });
    }

    drawRow = (item, index) => (
        <tr role="row" className="odd" key={item.id} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
            <td style={{ whiteSpace: 'nowrap' }}>{String(item.date || '').slice(0, 16).replace('T', ' ')}</td>
            <td>
                {item.recipient || <span className="text-muted">sin destinatario</span>}
                {/* Sin esta marca, las dos filas de una compra (la del cliente y la copia a info@)
                    se leen como un envío duplicado. */}
                {item.copyOf === 'internal' && (
                    <span className="badge badge-light ml-1" style={{ fontSize: 9 }}>copia interna</span>
                )}
            </td>
            <td>{item.subject || '—'}</td>
            <td>{nombreTipo(item.templateKey)}</td>
            <td>
                <span className={`badge ${badgeEstado(item.status)}`}>{textoEstado(item.status)}</span>
                {item.errorCode && <div className="text-muted" style={{ fontSize: 10 }}>{item.errorCode}</div>}
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>{textoReferencia(item.referenceType, item.referenceId)}</td>
            <td>
                <i className="material-icons" style={{ cursor: 'pointer', color: '#007bff' }}
                    title="Ver el mail" onClick={() => navigateTo('/emailLog/' + item.id)}>visibility</i>
            </td>
        </tr>
    )

    loadData = () => {
        if (!this.state.loaded) return <tbody></tbody>;
        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    onChangeShowRows = () => {
        this.fetchData({ page: 1, limit: Number(document.getElementById('select_rows').value) });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({ page: 1, sortBy: column, sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir) });
    }

    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                {this.renderResumen()}
                {this.renderFiltros()}

                {!this.state.loaded ? this.renderLoader() : (
                    <React.Fragment>
                        <div className="dataTables_length" id="DataTables_Table_0_length">
                            <label>Show
                            <select id="select_rows" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            entries</label>
                        </div>
                        <div id="DataTables_Table_0_filter" className="dataTables_filter">
                            <label>Buscar:
                            <input id="input_search" type="search" placeholder="destinatario o asunto"
                                value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)} />
                            </label>
                        </div>

                        <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid">
                            <thead>
                                <tr role="row">
                                    <th {...this.sortableHeader('created_at')} style={{ width: '14%' }}>Fecha y hora</th>
                                    <th {...this.sortableHeader('recipient')} style={{ width: '22%' }}>Para</th>
                                    <th style={{ width: '24%' }}>Asunto</th>
                                    <th {...this.sortableHeader('template_key')} style={{ width: '14%' }}>Tipo</th>
                                    <th {...this.sortableHeader('status')} style={{ width: '12%' }}>Estado</th>
                                    <th style={{ width: '10%' }}>Referencia</th>
                                    <th style={{ width: '4%' }}>Ver</th>
                                </tr>
                            </thead>
                            {this.loadData()}
                        </table>

                        <PaginationComponent
                            totalItems={this.state.totalItems}
                            quantityRows={this.state.quantityShowRows}
                            currentPage={this.state.currentPage}
                            onPageChange={(page) => this.fetchData({ page })}
                        />
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default TableEmailLogComponent;
